var _g, _circle, _circle2, _circle3, _circle4, _g2, _g3, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPriceCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 465,
    height: 465,
    viewBox: "0 0 465 465",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4089_17856)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 189.238,
    y: 180.087,
    width: 96.2828,
    height: 85.1885,
    rx: 7.92451,
    transform: "rotate(6.72195 189.238 180.087)",
    fill: "#53CD60"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 232.543,
    cy: 232.56,
    r: 163.785,
    transform: "rotate(6.72195 232.543 232.56)",
    stroke: "#5CDF6A",
    strokeOpacity: 0.1,
    strokeWidth: 90.2288,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.002,
    cy: 228.402,
    r: 142.275,
    transform: "rotate(6.72195 232.002 228.402)",
    stroke: "#5CDF6A",
    strokeOpacity: 0.3,
    strokeWidth: 28.369,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 231.998,
    cy: 228.411,
    r: 128.091,
    transform: "rotate(6.72195 231.998 228.411)",
    fill: "url(#paint0_linear_4089_17856)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 231.998,
    cy: 228.411,
    r: 110.038,
    transform: "rotate(6.72195 231.998 228.411)",
    stroke: "#5CDF6A",
    strokeOpacity: 0.65,
    strokeWidth: 36.106,
    strokeLinecap: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4089_17856)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 232.012,
    cy: 228.406,
    r: 71.0152,
    transform: "rotate(6.72195 232.012 228.406)",
    stroke: "#53CD60",
    strokeOpacity: 0.45,
    strokeWidth: 2.39377,
    strokeLinecap: "round",
    strokeDasharray: "9.97 9.97",
    shapeRendering: "crispEdges"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4089_17856)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 232.011,
    cy: 228.404,
    r: 47.2817,
    transform: "rotate(6.72195 232.011 228.404)",
    fill: "#357453"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.561 167.667C221.433 168.609 219.649 170.188 218.457 172.187L173.6 247.377C170.415 252.716 172.169 259.627 177.514 262.8L222.022 289.224C227.292 292.353 234.097 290.683 237.32 285.469L283.75 210.358C284.896 208.504 285.478 206.356 285.426 204.176L284.783 177.703C284.684 173.629 282.388 169.928 278.783 168.03L258 157.09C254.961 155.49 251.357 155.367 248.216 156.757L223.561 167.667ZM260.614 197.818C268.084 194.513 271.46 185.778 268.154 178.308C264.849 170.839 256.114 167.463 248.645 170.768C241.175 174.073 237.799 182.808 241.105 190.278C244.41 197.747 253.145 201.123 260.614 197.818Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M257.773 166.257C254.718 164.775 251.04 166.05 249.557 169.105C248.075 172.16 249.35 175.838 252.405 177.32L257.773 166.257ZM236.737 155.529L239.042 161.229L250.442 156.618L248.137 150.918L236.737 155.529ZM282.363 135.858L286.895 131.704L282.363 135.858ZM252.405 177.32C265.868 183.853 279.708 177.524 287.254 167.994C294.905 158.331 297.631 143.415 286.895 131.704L277.83 140.013C283.397 146.085 282.612 154.047 277.613 160.36C272.509 166.806 264.561 169.551 257.773 166.257L252.405 177.32ZM286.895 131.704C281.039 125.315 274.352 121.863 267.545 121.003C260.801 120.151 254.439 121.906 249.261 125.056C239.462 131.015 231.927 143.636 236.737 155.529L248.137 150.918C246.415 146.66 248.85 139.698 255.651 135.562C258.772 133.664 262.368 132.744 266.004 133.203C269.577 133.655 273.694 135.501 277.83 140.013L286.895 131.704Z",
    fill: "#E2B93B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4089_17856",
    x: 38.2944,
    y: 39.1147,
    width: 387.538,
    height: 377.818,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 70.9226,
    result: "effect1_foregroundBlur_4089_17856"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4089_17856",
    x: 141.444,
    y: 140.66,
    width: 181.137,
    height: 181.137,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.82296
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.17463
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4089_17856"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4089_17856",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4089_17856",
    x: 140.969,
    y: 137.362,
    width: 182.085,
    height: 182.085,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 21.878
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4089_17856"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4089_17856",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4089_17856",
    x1: 162.837,
    y1: 116.902,
    x2: 365.738,
    y2: 316.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19253D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#203D77"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceCircle);
export default __webpack_public_path__ + "static/media/price-circle.fea7c986536842943fd778889ac2f5af.svg";
export { ForwardRef as ReactComponent };